import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

// O "?" com a explicação do campo (Adnéia, 04/11/2026: "em cada ponto do ELO, uma interrogação
// explicando o que precisa fazer ali", para o Caio e a Gabi aprenderem pelo próprio card).
// Abre ao parar o mouse em cima; um clique deixa aberto (o celular só tem o clique); clicar fora
// ou Esc fecha. O texto de cada campo é o que ela aprovou: não escrever regra que não está escrita.
export default function AjudaCampo({ titulo, children, testid }) {
  const [passando, setPassando] = useState(false);
  const [fixo, setFixo] = useState(false);
  return (
    <Popover open={passando || fixo} onOpenChange={(v) => { if (!v) { setFixo(false); setPassando(false); } }}>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`O que fazer: ${titulo}`} data-testid={testid}
          onMouseEnter={() => setPassando(true)} onMouseLeave={() => setPassando(false)}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setFixo((f) => !f); }}
          className="inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border border-muted-foreground/60 text-[9px] font-bold leading-none text-muted-foreground hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring">
          ?
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" className="w-72 whitespace-normal p-3 text-xs leading-relaxed"
        onOpenAutoFocus={(e) => e.preventDefault()}>
        <p className="mb-1 font-semibold">{titulo}</p>
        <p>{children}</p>
      </PopoverContent>
    </Popover>
  );
}
